/**
 * Cartão de chamado no tablet de sala.
 *
 * new      → vermelho, a piscar
 * accepted → amarelo, sem piscar
 * completed→ verde (alguns segundos, depois sai do quadro)
 */
import { STATUS_LABELS, TYPE_LABELS, formatWaiting } from "@/utils/kaysouAssistState";

const TONES = {
  new: { card: "bg-red-600 border-red-400 animate-pulse", text: "text-white", sub: "text-red-100" },
  accepted: { card: "bg-amber-400 border-amber-300", text: "text-gray-900", sub: "text-amber-900" },
  completed: { card: "bg-emerald-600 border-emerald-400", text: "text-white", sub: "text-emerald-100" },
};

export function AssistRequestCard({ request, nowMs, onAccept, onComplete }) {
  const isPaid = request.type === "bill" && request.payment_status === "paid";
  const tone = isPaid ? TONES.completed : (TONES[request.status] || TONES.new);
  const tableLabel = request.table_name
    || (request.table_number != null ? `MESA ${String(request.table_number).padStart(2, "0")}` : "MESA");

  return (
    <div
      className={`rounded-2xl border-2 p-4 flex flex-col gap-3 shadow-lg ${tone.card}`}
      data-testid={`assist-card-${request.id}`}
      data-status={request.status}
    >
      <div>
        <p className={`text-2xl font-black tracking-wide ${tone.text}`}>{tableLabel}</p>
        <p className={`text-base font-semibold ${tone.text}`}>
          {isPaid ? "MESA PAGADA" : (TYPE_LABELS[request.type] || request.type)}
        </p>
        <p className={`text-sm ${tone.sub}`}>
          {isPaid ? "PAGO CONFIRMADO" : (STATUS_LABELS[request.status] || request.status)} · {formatWaiting(request.created_at, nowMs)}
          {request.accepted_by_name ? ` · ${request.accepted_by_name}` : ""}
        </p>
      </div>

      {isPaid ? (
        <div className="h-12 rounded-xl bg-white/95 text-emerald-700 font-black text-sm flex items-center justify-center"
          data-testid={`assist-paid-${request.id}`}>
          MESA PAGADA
        </div>
      ) : (
      <div className="grid grid-cols-2 gap-2">
        <button
          type="button"
          onClick={() => onAccept(request.id)}
          disabled={request.status !== "new"}
          className="h-12 rounded-xl bg-white/95 text-gray-900 font-bold text-sm disabled:opacity-40"
          data-testid={`assist-accept-${request.id}`}
        >
          ACEPTAR
        </button>
        <button
          type="button"
          onClick={() => onComplete(request.id)}
          disabled={request.status === "completed"}
          className="h-12 rounded-xl bg-gray-900/85 text-white font-bold text-sm disabled:opacity-40"
          data-testid={`assist-complete-${request.id}`}
        >
          ATENDIDO
        </button>
      </div>
      )}
    </div>
  );
}
